// Vendor imports
const Immutable = require('immutable')
// Common imports
const ArticleProfileModalRecord = require('client-v2/common/containers/article-profile/state/modal-record')
const ArticleProfileSlideRecord = require('client-v2/common/containers/article-profile/state/slide-record')
const AuthModalRecord = require('client-v2/common/containers/auth-modal/record')
const { keyedReviver } = require('client-v2/common/state/record-reviver')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const UserRecord = require('client-v2/common/state/user/record')

class ArticleProfileRootRecord extends Immutable.Record({
  // Common state
  env: null,
  router: null,
  user: null,
  // Common containers
  articleProfile: null,
  articleProfileModal: null,
  authModal: null
}) {
  // No methods yet
}

ArticleProfileRootRecord.reviver = keyedReviver(ArticleProfileRootRecord, {
  // Common state records
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: UserRecord.reviver,
  // Common container records
  articleProfile: ArticleProfileSlideRecord.reviver,
  articleProfileModal: ArticleProfileModalRecord.reviver,
  authModal: AuthModalRecord.reviver
})

module.exports = ArticleProfileRootRecord
